import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../shared/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ContactTemp } from '../../../entities/contact-temp.model';
import { Booth, Contact, ContactStatus, Marketdate } from '../../../entities';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { JhiLanguageService } from 'ng-jhipster';
import { Observable } from 'rxjs/Observable';
import { LocalStorageService } from 'ng2-webstorage';
import { EventManager } from '@angular/platform-browser';
import { isNumeric } from 'rxjs/util/isNumeric';
import { Headers, Http } from '@angular/http';
import { GoogleMapsLocation, GoogleMapsResponse } from '../../../entities/google-maps-data.model';
import { TRAINING } from '../../../app.constants';
import { classToClass, plainToClass } from 'class-transformer';
import {
  Image,
  PaymentMethod,
  PaymentMethodLabel,
  PaymentMethodValue,
  SocialMedia, SocialMediaLabel, SocialMediaName, SocialMediaValue,
  MarketWebsiteMerchant, Description
} from '../../../entities/market-website-merchant.model';
import {MerchantChange} from '../../../entities/merchant-change.model';
import {WebBaseDataService} from '../../../shared/web-base-data/web-base-data.service';

declare const ym;

@Component({
  selector: 'app-contact-detail',
  templateUrl: './contact-detail.component.html',
  styleUrls: ['./contact-detail.component.scss']
})
export class ContactDetailComponent implements OnInit {

  contactId: number;
  merchant: Contact;
  acceptContactPersonDataModalStep: number;

  contactBefore: ContactTemp;
  contactApp: ContactTemp;
  contactWeb: MarketWebsiteMerchant;
  contactWebOrigin: MarketWebsiteMerchant;
  contactResult: ContactTemp;
  contactTemp: ContactTemp;

  merchantChange: MerchantChange;
  webContactBefore: MarketWebsiteMerchant = new MarketWebsiteMerchant();
  hasDescriptionBefore = false;
  hasDescriptionAfter = false;

  selectedImage: Image;
  selectedImages: Image[];
  imgRemoveButtontext = '&#10060;';

  paymentMethods: PaymentMethod[];
  socialMedias: SocialMedia[];

  causingMarketMaster: Contact;
  causedOnMarketdate: Marketdate;

  modalRef: any = null;
  archive: boolean;
  loadingIndicator = true;
  loadingAddressCheck = false;
  includeHeaderImage = true;

  useLastMarketDetail: boolean;
  lastMarketDetail: string;
  lastMarketDetailTitle: string;

  yellowMapData = {
    country: '',
    city: '',
    suburb: '',
    zip: '',
    street: ''
  };

  mlAddressData = {
    country: '',
    city: '',
    suburb: '',
    zip: '',
    street: ''
  };

  addressResultData = {
    country: '',
    city: '',
    suburb: '',
    zip: '',
    street: ''
  };

  possibleDuplicates: Contact[];
  possibleDuplicatesOriginal: Contact[];
  duplicatesLoading = false;
  selectedDuplicate: Contact | ContactTemp;
  selectedDuplicateCopy: Contact | ContactTemp;
  marketdateBooths: Booth[];
  yellowMapException: {
    errCode: string,
    publicReport: string
  };
  error: any;
  errorModalDetails = false;

  @ViewChild('acceptContactPersonDataModal') private acceptContactPersonDataModal;
  @ViewChild('addressCheckModal') private addressCheckModal;
  @ViewChild('duplicateMerchantsModal') private duplicateMerchantsModal;
  @ViewChild('duplicateContactPersonsModal') private duplicateContactPersonsModal;
  @ViewChild('errorModal') private errorModal;

  trainingSystem = TRAINING;

  constructor(
    private apiService: ApiService,
    private route: ActivatedRoute,
    public router: Router,
    private jhiLanguageService: JhiLanguageService,
    public modalService: NgbModal,
    private localStorage: LocalStorageService,
    private events: EventManager,
    private http: Http,
    private webBaseDataService: WebBaseDataService,
  ) {
    this.jhiLanguageService.setLocations(['base-data']);
    this.archive = this.router.url.split('/company')[0] === '/base-data-archive';

    this.events.addGlobalEventListener('window', 'ymDataEvent', (event) => {
      this.yellowMapData = event.detail;

      if (this.contactApp) {
        this.mlAddressData = {
          country: this.contactApp.country,
          city: this.contactApp.city,
          suburb: this.contactApp.suburb,
          zip: this.contactApp.zipcode,
          street: this.contactApp.street
        };
      }

      this.addressResultData = {
        country: this.yellowMapData.country,
        city: this.yellowMapData.city,
        suburb: this.yellowMapData.suburb,
        zip: this.yellowMapData.zip,
        street: this.yellowMapData.street
      };

      this.loadingAddressCheck = false;
    });

    this.events.addGlobalEventListener('window', 'ymException', (event) => {

      this.yellowMapException = {
        errCode: (event.detail.errCode) ? event.detail.errCode : '',
        publicReport: (event.detail.publicReport) ? event.detail.publicReport : ''
      };

      this.mlAddressData = {
        country: this.contactApp.country,
        city: this.contactApp.city,
        suburb: this.contactApp.suburb,
        zip: this.contactApp.zipcode,
        street: this.contactApp.street
      };

      this.addressResultData = {
        country: this.contactApp.country,
        city: this.contactApp.city,
        suburb: this.contactApp.suburb,
        zip: this.contactApp.zipcode,
        street: this.contactApp.street
      };

      this.loadingAddressCheck = false;
    });

    this.merchantChange = this.webBaseDataService.selectedMerchantChange;
    this.paymentMethods = this.enumKeys(PaymentMethodValue).map(key => ({value: PaymentMethodValue[key], label: PaymentMethodLabel[key]}));
    this.socialMedias = this.enumKeys(SocialMediaValue)
      .map(key => ({name: {value: SocialMediaValue[key], label: SocialMediaLabel[key]}, type: 'SocialMedia', link: ''}));
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.contactId = +params['id'];
      this.load(this.contactId);
    });

    this.route.queryParams.subscribe(queryParams => {
      this.useLastMarketDetail = (queryParams && queryParams['useLastMarketDetail']) || false;
      if (this.useLastMarketDetail) {
        this.lastMarketDetail = this.localStorage.retrieve('lastMarketDetail');
        this.lastMarketDetailTitle = this.localStorage.retrieve('lastMarketDetailTitle');
      }
    });
  }

  getYellowMapData() {
    this.loadingAddressCheck = true;
    this.yellowMapException = null;

    this.contactTemp = classToClass(this.contactApp);
    this.contactApp = classToClass(this.contactResult);

    this.mlAddressData = {
      country: '',
      city: '',
      suburb: '',
      zip: '',
      street: ''
    };

    this.openAddressCheckModal();

    const houseNumberRegex = new RegExp(/\d+\w*\s*(?:[\-\/]?\s*)?\d*\s*\w*\/?\s*\d*\s*/);
    const houseNumberRegexResult = houseNumberRegex.exec(this.contactApp.street);
    const houseNumberIndex = (houseNumberRegexResult && houseNumberRegexResult.length > 0) ? houseNumberRegexResult['index'] : -1;
    const houseNumber = (houseNumberRegexResult && houseNumberRegexResult.length > 0) ? houseNumberRegexResult[0] : '';
    const street = (houseNumberRegexResult && houseNumberRegexResult.length > 0) ?
      this.contactApp.street.substring(0, houseNumberIndex) : this.contactApp.street;

    ym.ready((modules) => {
      const geocoder = new ym.services.GeoCoder();
      geocoder.geocode(
        {
          country: this.contactApp.country,
          zip: this.contactApp.zipcode,
          city: this.contactApp.city,
          street: street,
          houseNo: houseNumber
        },
        {
          coordFormat: 'GEODECIMAL_POINT',
          locale: 'de-DE'
        }
      );
      geocoder.on('success', (request, response) => {
        const ymData = {
          country: '',
          city: '',
          suburb: '',
          zip: '',
          street: ''
        };

        if (response.body && response.body.features && response.body.features.length > 0) {
          response.body.features.forEach((feature, index) => {

            const isoMapping = {
              'DE': 'Deutschland'
            };

            for (const propertiesKey in feature.properties) {
              if (propertiesKey && feature.properties[propertiesKey]) {
                switch (propertiesKey) {
                  case 'isoCountry':
                    ymData.country = isoMapping[feature.properties[propertiesKey]];
                    break;
                  case 'city':
                    ymData.city = feature.properties[propertiesKey];
                    break;
                  case 'cityPart':
                    ymData.suburb = feature.properties[propertiesKey];
                    break;
                  case 'zip':
                    ymData.zip = feature.properties[propertiesKey];
                    break;
                  case 'street':
                    ymData.street = feature.properties[propertiesKey] + ((houseNumber !== '') ? ' ' : '') + houseNumber;
                    break;
                }
              }
            }
            if (response.body.features.length === index + 1) {
              window.dispatchEvent(new CustomEvent('ymDataEvent', {detail: ymData}));
            }
          });
        } else if (response.body.properties.exception) {
          console.log('yellowmaps error: ', response.body);
          window.dispatchEvent(new CustomEvent('ymException', {detail: response.body.properties.exception}));
        }
      });

    }, this.contactApp);
  }

  load(id: number) {
    this.loadingIndicator = true;
    this.apiService.findRegular<ContactTemp>(ContactTemp, 'contact-temps-changes/' + id + '/true/' + this.archive.toString()).subscribe(
      contact => {
        if (contact && contact.length > 0) {
          this.contactBefore = contact.filter((item) => item.status === 'Before')[0];
          this.contactApp = contact.filter((item) => item.status === 'After' || item.status === 'New')[0];
        }

        if (!this.contactApp) {
          return;
        }

        this.merchant = ((this.contactApp.casIsCompany) ? this.contactApp : this.contactApp.superordinateContact) as Contact;

        if (this.contactApp.updatedBy) {
          this.getContactByUserId(this.contactApp.updatedBy.id).subscribe(causingMm => this.causingMarketMaster = causingMm);
        }
        this.causedOnMarketdate = this.contactApp.marketdate;

        this.getMarketdateBooths().then((marketdateBooths => {
          this.marketdateBooths = marketdateBooths;
          this.loadingIndicator = false;
        }));
        // deep clone
        this.contactResult = classToClass(this.contactApp);
        if (this.contactBefore) {
          this.contactResult.responsibleAccordingToTMG = this.contactBefore.responsibleAccordingToTMG;
        }
        this.findSimilarContacts(this.contactApp.casIsCompany);
      }, (error) => {
        console.warn('Could not load contact temp changes.', error);
        this.error = error;
        this.loadingIndicator = false;
      }
    );
    this.loadMerchantChange(id).then(() => this.loadWebData(id).then(() => {
      this.loadingIndicator = false;
      this.initWithWebData();
    })).catch((error) => {
      console.log('Error: ', error);
      this.error = error;
      this.loadingIndicator = false;
    }).catch((error) => this.error = error);
  }

  loadMerchantChange(id: number) {
    return new Promise((resolve, reject) => {
      this.apiService.get('backoffice/merchant-changes-by-original-contact/' + id + '/' + this.archive.toString()).subscribe((data) => {
        this.merchantChange = plainToClass(MerchantChange, JSON.parse(data._body));
        resolve();
      }, (err) => reject(err));
    });
  }

  /**
   * Loads company details data before and after they got changed
   */
  loadWebData(id: number) {
    if (!this.merchantChange) { return; }
    return Promise.all<MarketWebsiteMerchant>([this.merchantChange.marketwebsitePublishedVersion, this.merchantChange.marketwebsiteVersion]
      .map(versionId => {
        return new Promise((resolve, reject) => {
          // Changed this because MarketWebsiteMerchant.image doesn't got assigned properly by json-typescript-mapper.
          // With class-transformer everything works as expected
          this.apiService.get(['backoffice', 'merchant-changes',
            this.merchantChange.marketwebsiteId, versionId].join('/'))
            .subscribe((result) => resolve(plainToClass(MarketWebsiteMerchant, JSON.parse(result._body))), e => reject(e));
        });
      })
    ).then((webCompanyDetailsData: MarketWebsiteMerchant[]) => {
      this.webContactBefore = webCompanyDetailsData[0];
      if (!this.webContactBefore.pendingVersion) {
        this.webContactBefore.pendingVersion = this.merchantChange.marketwebsiteVersion;
      }
      this.hasDescriptionBefore = this.webContactBefore.description.length > 0;
      if (!this.webContactBefore.socialMedia) { this.webContactBefore.socialMedia = []; }
      if (!this.webContactBefore.updated) { this.webContactBefore.updated = this.merchantChange.originalContact.updated; }
      this.contactWeb = webCompanyDetailsData[1];
      if (!this.contactWeb.pendingVersion) {
        this.contactWeb.pendingVersion = this.merchantChange.marketwebsiteVersion;
      }
      if (!this.contactWeb.updated) { this.contactWeb.updated = this.merchantChange.updated; }
      this.contactWebOrigin = classToClass(this.contactWeb);
      this.socialMedias.forEach((social) => {
        if (!this.contactWeb.socialMedia.some(item => item.name.value === social.name.value)) {
          this.contactWeb.socialMedia.push(social);
        }
      });
      this.hasDescriptionAfter = this.contactWeb.description.length > 0;
      this.selectedImages = this.hasDescriptionAfter ? this.contactWeb.description[0].imageGallery : [];
      if (!this.contactWeb.socialMedia) { this.contactWeb.socialMedia = []; }
      if (this.contactWeb.responsibleAccordingToTMG !== null) {
        this.contactResult.responsibleAccordingToTMG = this.contactWeb.responsibleAccordingToTMG;
      }
    }).catch(error => {
      console.log('error loading data', error);
      this.error = error;
      this.loadingIndicator = false;
    });
  }

  initWithWebData() {
    if (!this.contactBefore && this.webContactBefore) {
      this.contactBefore = new ContactTemp();
      const obj = this.merchantChange.originalContact;
      for (const key of Object.keys(obj)) {
        if (key in this.contactBefore) {
          this.contactBefore[key] = obj[key];
        }
      }
    }
    if (!this.contactResult) {
      this.contactResult = new ContactTemp(true);
      for (const key of Object.keys(this.contactWeb)) {
        if (this.contactResult[key] !== undefined) {
          this.contactResult[key] = this.contactWeb[key];
        }
      }
      this.contactResult.radius = this.merchantChange.radius;
    }
  }

  getMarketdateBooths(): Promise<any> {
    return new Promise<any>(resolve => {
      const url = 'marketdate-booths-by-' + ((this.contactApp.casIsCompany) ? 'merchant' : 'contact-person') + '/'
        + this.contactApp.originalContact.id;
      this.apiService.find<Booth>(Booth, url)
        .subscribe(marketdateBooths => {
          resolve(marketdateBooths);
        });
    });
  }

  openModal(modal: any, options: NgbModalOptions) {
    this.modalRef = this.modalService.open(modal, options);
  }

  acceptData() {
    this.loadingIndicator = true;
    this.duplicatesLoading = true;
    this.acceptWebData().then(() => {
      if (!this.contactApp || !this.causedOnMarketdate) {
        this.router.navigate(['/base-data/company', this.contactId], {queryParamsHandling: 'preserve'}).then();
      }
    });
    if (!this.contactApp || !this.causedOnMarketdate) {
      this.loadingIndicator = false;
      this.duplicatesLoading = false;
      return;
    }
    if (this.contactApp.status !== 'New' || this.selectedDuplicate === this.contactApp) {
      const originalContact = this.contactApp.originalContact;

      let companyId = 0;
      if (this.contactApp.casIsCompany) {
        companyId = this.contactApp.originalContact.id;
      } else if (this.contactApp.casIsContact) {
        companyId = this.contactApp.superordinateContact.id;
      }

      // Update the original contact
      if (originalContact) {
        this.contactApp.id = originalContact.id;
      }
      this.contactApp.status = 'Accepted';
      this.apiService.putRegular(this.contactApp, 'contacts/' + this.causedOnMarketdate.id).subscribe(
        response => {
          this.loadingIndicator = false;
          this.duplicatesLoading = false;
          if (this.modalRef) {
            this.modalRef.close();
          }
          this.router.navigate(['/base-data/company', companyId], {queryParamsHandling: 'preserve'});
        }, error => {
          this.loadingIndicator = false;
          this.duplicatesLoading = false;
        });
    } else {
      const url = 'use-duplicate-' + ((this.contactApp.casIsCompany) ? 'merchant/' : 'contact-person/');
      const marketdateBoothId = ((this.marketdateBooths && this.marketdateBooths.length >= 1) ? this.marketdateBooths[0].id : 0).toString();
      this.apiService.get(url + this.contactApp.originalContact.id + '/' + this.selectedDuplicate.id + '/' + marketdateBoothId)
        .subscribe(result => {
          const merchantId = result.json();

          if (this.contactApp.casIsContact && this.checkForDuplicateChanges()) {
            this.selectedDuplicate.status = ContactStatus.AcceptedWithChanges;
            this.apiService.putRegular(this.selectedDuplicate, 'contacts/' + this.causedOnMarketdate.id).subscribe(
              response => {
                this.loadingIndicator = false;
                this.duplicatesLoading = false;

                if (this.modalRef) {
                  this.modalRef.close();
                }
                this.router.navigate(['/base-data/company', merchantId], {queryParamsHandling: 'preserve'}).then();
              }, error => {
                this.loadingIndicator = false;
                this.duplicatesLoading = false;

                if (this.modalRef) {
                  this.modalRef.close();
                }
                this.router.navigate(['/base-data/company', merchantId], {queryParamsHandling: 'preserve'}).then();
              });
          } else {
            if (this.modalRef) {
              this.modalRef.close();
            }
            this.router.navigate(['/base-data/company', merchantId], {queryParamsHandling: 'preserve'}).then();
          }
        });
    }
  }

  /**
   * Applies user data changes to MarketWebsiteMerchant and sends data to api
   */
  acceptWebData(): Promise<any> {
    return new Promise((resolve, reject) => {
      if (!this.contactWeb) {
        return resolve();
      }
      if (!this.contactWeb.id || !this.contactWeb.pendingVersion) {
        this.modalService.open(this.errorModal, {size: 'sm'});
        return reject();
      }
      this.applyDataChanges();

      const applyChangesToContact = (contactStatus: ContactStatus) => {
        // Send contact changes to api
        this.merchantChange.status = contactStatus;
        this.apiService.putRegular(this.merchantChange, 'backoffice/apply-changes-to-contact')
          .subscribe((res) => {}, (err) => {
            this.handleError(err, 'backoffice/apply-changes-to-contact');
          });
      };

      if (this.hasContactWebChanges()) {
        // Send changed merchant changes to api
        applyChangesToContact(ContactStatus.AcceptedWithChanges);
        this.apiService.putRegular(this.filterSocialMedia(this.contactWeb), 'backoffice/merchant-changes')
          .subscribe((res) => resolve(), (err) => {
            this.handleError(err, 'backoffice/merchant-changes');
            reject(err);
          });
      } else {
        // Send untouched merchant changes to api
        applyChangesToContact(ContactStatus.Accepted);
        this.apiService.putRegular(this.filterSocialMedia(this.contactWeb), 'backoffice/accept-all-merchant-changes')
          .subscribe((res) => resolve(), (err) => {
            this.handleError(err, 'backoffice/accept-all-merchant-changes');
            reject(err);
          });
      }
    });
  }

  revokeData() {
    if (this.contactApp) {
      this.loadingIndicator = true;
      const originalContact = this.contactApp.originalContact;

      let companyId = 0;
      if (this.contactApp.casIsCompany) {
        companyId = this.contactApp.originalContact.id;
      } else if (this.contactApp.casIsContact) {
        companyId = this.contactApp.superordinateContact.id;
      }

      // Update the original contact
      const updateOriginalContactPromise = new Promise((resolve, reject) => {
        this.contactBefore.id = originalContact.id;
        this.contactBefore.status = null;
        this.apiService.putRegular(this.contactBefore, 'contacts/' + this.contactBefore.marketdate.id).subscribe(
          response => {
            resolve();
          }, error => reject(error));
      });

      Promise.all([updateOriginalContactPromise]).then(() => {
        // Revoke the corresponding contactTemps
        const revokePromise = new Promise((resolve, reject) => {
          this.apiService.get('contact-temps-revoke-by-original/' + originalContact.id).subscribe(() => {
            this.loadingIndicator = false;
            if (this.modalRef) {
              this.modalRef.close();
            }
            this.router.navigate(['/base-data/company', companyId], {queryParamsHandling: 'preserve'}).then();
          }, error => reject(error));
        });
      }, error => this.loadingIndicator = false);
    }

    // Reject changes from merchant website
    if (this.contactWeb) {
      this.apiService.put(this.contactWeb, 'backoffice/reject-all-merchant-changes')
        .subscribe({
          next: () => {
            if (!this.contactApp) {
              if (this.modalRef) {
                this.modalRef.close();
              }
              this.router.navigate(['/base-data/company', this.contactWeb.marketmanagerOriginalId],
                {queryParamsHandling: 'preserve'}).then();
            }
          },
          error: (error) => console.log('Could not reject merchant changes!', error)
        });
    }

  }

  getContactByUserId(userId: number): Observable<Contact> {
    return this.apiService.findOne<Contact>(Contact, 'contact-by-user/' + userId);
  }

  openAddressCheckModal() {
    this.openModal(this.addressCheckModal, {size: 'lg'});
  }

  getAddressCoords(): void {
    const addressParam = this.addressResultData.street
      + '+' + this.addressResultData.zip
      + '+' + this.addressResultData.city
      + '+' + this.addressResultData.country;
    const googleMapsApiUrl = 'https://maps.googleapis.com/maps/api/geocode/json';
    const googleMapsApiKey = 'AIzaSyBwUC5Zhll-DNN34HLfoaNQaKF2ByqNcWU';

    let resultCoordinates: GoogleMapsLocation = { lat: 0, lng: 0 };
    const headers = new Headers();
    headers.append('Authorization', 'BLOCK');
    this.http.get(googleMapsApiUrl + '?key=' + googleMapsApiKey + '&address=' + addressParam, {headers: headers})
      .subscribe(res => {
        const googleMapsResponse = res.json() as GoogleMapsResponse;
        if (googleMapsResponse.results.length > 0
          && googleMapsResponse.results[0]
          && googleMapsResponse.results[0].geometry
          && googleMapsResponse.results[0].geometry.location) {
          resultCoordinates = googleMapsResponse.results[0].geometry.location;
        }
        this.saveResultAddress(resultCoordinates);
      }, error => {
        console.log('error:', error);
        this.saveResultAddress(resultCoordinates);
      });
  }

  saveResultAddress(coords: GoogleMapsLocation) {
    this.modalRef.close();
    this.loadingIndicator = true;

    for (const key of Object.keys(this.addressResultData)) {
      if (key in this.contactResult) {
        this.contactResult[key] = this.addressResultData[key];
      }
    }

    const originalContact = this.contactApp.originalContact;
    const contactTemp = this.contactApp;

    originalContact.company = contactTemp.company;
    originalContact.companyAdditional = contactTemp.companyAdditional;
    originalContact.phone = contactTemp.phone;
    originalContact.fax = contactTemp.fax;
    originalContact.email = contactTemp.email;
    originalContact.web = contactTemp.web;

    originalContact.country = this.addressResultData.country;
    originalContact.city = this.addressResultData.city;
    originalContact.suburb = this.addressResultData.suburb;
    originalContact.zipcode = this.addressResultData.zip;
    originalContact.street = this.addressResultData.street;
    originalContact.latitude = coords.lat.toString();
    originalContact.longitude = coords.lng.toString();

    contactTemp.country = this.addressResultData.country;
    contactTemp.city = this.addressResultData.city;
    contactTemp.suburb = this.addressResultData.suburb;
    contactTemp.zipcode = this.addressResultData.zip;
    contactTemp.street = this.addressResultData.street;
    contactTemp.latitude = coords.lat.toString();
    contactTemp.longitude = coords.lng.toString();

    const originalContactPromise = new Promise(resolve => {
      this.apiService.putRegular(originalContact, 'contacts-backoffice/').subscribe(result => {
        resolve(result.json());
      });
    });

    const contactTempPromise = new Promise(resolve => {
      this.apiService.putRegular(contactTemp, 'contact-temps-address-update').subscribe(result => {
        this.contactApp = result.json() as ContactTemp;
        resolve(result.json());
      });
    });

    Promise.all([originalContactPromise, contactTempPromise]).then((results) => {
      this.loadingIndicator = false;
      if (this.contactApp.status === 'New') {
        this.checkDuplicates();
      } else {
        this.acceptData();
      }
    });
  }

  checkDuplicates() {
    if (this.modalRef) {
      this.modalRef.close();
    }
    this.findSimilarContacts(this.contactApp.casIsCompany);
    if (this.contactApp.casIsCompany) {
      this.openModal(this.duplicateMerchantsModal, {size: 'lg', windowClass: 'xl'});
    } else {
      this.openModal(this.duplicateContactPersonsModal, {size: 'lg', windowClass: 'xl'});
    }
  }

  findSimilarContacts(casIsCompany: boolean) {
    this.duplicatesLoading = true;
    const url = (casIsCompany) ? 'similar-contacts/' + this.contactApp.originalContact.id
      : 'contacts/' + this.merchant.id + '/subordinate-contacts';
    this.apiService.find<Contact>(Contact, url)
      .subscribe((duplicatesResult: Contact[]) => {
        if (casIsCompany) {
          this.possibleDuplicates = duplicatesResult;
        } else {
          this.possibleDuplicates = duplicatesResult
            .filter(c => c.id !== this.contactApp.originalContact.id && c.status !== ContactStatus.Deleted);
        }

        this.possibleDuplicatesOriginal = [];
        this.possibleDuplicates.forEach((contact: Contact) =>
          this.possibleDuplicatesOriginal.push(Object.assign<Contact, Contact>(new Contact(), (contact as Contact))));

        this.selectedDuplicate = this.contactApp;
        this.duplicatesLoading = false;
      });
  }

  getDuplicateHint(): string {
    const contactType = (this.contactApp.casIsCompany) ? 'Beschicker' : 'Verkaufspersonal';
    let result = 'Es wurde mindestens ein mögliches Duplikat zu dem neu erfassten ' + contactType + ' gefunden.';
    if (this.possibleDuplicates && isNumeric(this.possibleDuplicates.length)) {
      switch (this.possibleDuplicates.length) {
        case 1:
          result = 'Es wurde ' + this.possibleDuplicates.length + ' mögliches Duplikat zu dem neu erfassten ' + contactType + ' gefunden.';
          break;
        default:
          result = 'Es wurden ' + this.possibleDuplicates.length + ' mögliche Duplikate zu dem neu erfassten ' + contactType + ' gefunden.';
          break;
      }
    }
    return result;
  }

  changeSelectedDuplicate(selected) {
    this.selectedDuplicate = (selected !== this.selectedDuplicate) ? selected : null;
  }

  checkForDuplicateChanges(): boolean {
    const selectedContact = this.selectedDuplicate;
    const selectedContactOriginal = this.possibleDuplicatesOriginal.find(contact => contact.id === selectedContact.id);
    return (JSON.stringify(selectedContact) !== JSON.stringify(selectedContactOriginal));
  }

  saveContact() {
    const duplicateSame = this.contactApp === this.selectedDuplicate;
    this.contactTemp = classToClass(this.contactApp);
    this.contactApp = classToClass(this.contactResult);
    if (duplicateSame) { this.selectedDuplicate = this.contactApp; }

    if (this.contactWeb) {
      return this.acceptData();
    }
    return this.acceptContactPersonData();
  }

  acceptContactPersonData() {
    this.selectedDuplicateCopy = Object.assign<Contact, Contact>(new Contact(), (this.selectedDuplicate as Contact));
    this.acceptContactPersonDataModalStep = 0;
    this.openModal(this.acceptContactPersonDataModal, {size: 'lg'});
  }

  /**
   * Pushes to or removes an image from this.selectedImages
   */
  toggleImage(index: number, btn: HTMLButtonElement, doc: HTMLImageElement) {
    if (doc.style.filter) {
      // Undo image remove
      doc.style.filter = null;
      btn.innerHTML = '&#10060;';
      this.selectedImages.push(this.contactWeb.description[0].imageGallery[index]);
    } else {
      // Remove image
      doc.style.filter = 'grayscale(1)';
      btn.innerHTML = '&#10004;';
      this.selectedImages = this.contactWeb.description[0].imageGallery.filter((item, i) => i !== index);
    }
  }

  toggleHeaderImage(btn: HTMLButtonElement, doc: HTMLImageElement) {
    if (this.includeHeaderImage) {
      doc.style.filter = 'grayscale(1)';
      btn.innerHTML = '&#10004;';
      this.includeHeaderImage = false;
    } else {
      doc.style.filter = null;
      btn.innerHTML = '&#10060;';
      this.includeHeaderImage = true;
    }
    this.hasContactWebChanges();
  }

  getSocialMedia(webContact: MarketWebsiteMerchant, name: SocialMediaName): SocialMedia {
    if (!webContact) { return new SocialMedia(true); }
    if (!webContact.socialMedia) {
      webContact.socialMedia = [];
    }
    const result = webContact.socialMedia.filter((item) => item.name.value === name.value);
    if (result.length < 1) {
      const social = new SocialMedia(true);
      social.name = name;
      social.link = '';
      social.type = 'SocialMedia';
      webContact.socialMedia.push(social);
    }
    return webContact.socialMedia.filter((item) => item.name.value === name.value)[0];
  }

  filterSocialMedia(webContact: MarketWebsiteMerchant): MarketWebsiteMerchant {
    webContact.socialMedia = webContact.socialMedia.filter((social) => social.link && social.link.length > 0);
    return webContact;
  }

  getPayment(webContact: MarketWebsiteMerchant, payment: PaymentMethod) {
    if (!webContact || !webContact.paymentMethods) { return null; }
    const result = webContact.paymentMethods.filter((item) => item.value === payment.value);
    return result.length > 0 ? result[0] : null;
  }

  /**
   * Set or unset a payment method from a given contact. If contact has payment method, payment method will be removed
   * @param contact the web contact to toggle the payment method
   * @param payment the payment method to set or unset
   * @param checked If true payment gets set. If false payment gets unset. Leave undefined for toggle mode
   */
  setPayment(contact: MarketWebsiteMerchant, payment: PaymentMethod, checked?: boolean) {
    if (!contact.paymentMethods) { contact.paymentMethods = []; }
    if (checked) {
      if (!contact.paymentMethods.some(item => item.value === payment.value)) {
        contact.paymentMethods.push(payment);
      }
    } else if (checked === false) {
      contact.paymentMethods = contact.paymentMethods.filter(pay => pay.value !== payment.value);
    } else if ((contact.paymentMethods.some(item => item.value === payment.value))) {
      contact.paymentMethods = contact.paymentMethods.filter(pay => pay.value !== payment.value);
    } else {
      contact.paymentMethods.push(payment);
    }
  }

  /**
   * Compares contactWeb with webContactBefore at the given property key.
   * @returns true if the given property has changed in contactWeb compared to webContactBefore
   * @param key the property key to compare
   */
  hasDescriptionAttributeChanged(key: string): boolean {
    if (!this.hasDescriptionBefore && this.hasDescriptionAfter) {
      return this.contactWeb.description[0][key] !== undefined && this.contactWeb.description[0][key] !== '';
    }
    if (this.hasDescriptionBefore && !this.hasDescriptionAfter) {
      return this.webContactBefore.description[0][key] && this.webContactBefore.description[0][key] !== '';
    }
    if (this.hasDescriptionBefore && this.hasDescriptionAfter) {
      return this.webContactBefore.description[0][key] !== this.contactWeb.description[0][key];
    }
    return false;
  }

  /**
   * Checks if any value from this.contactWeb has changed
   */
  hasContactWebChanges(): boolean {
    let hasChanges = false;
    for (const key of Object.keys(this.contactWeb)) {
      switch (key) {
        case 'description': {
          if (!this.hasDescriptionAfter) { break; }
          if ((this.selectedImages && this.contactWebOrigin.description[0].imageGallery
            && this.selectedImages.length !== this.contactWebOrigin.description[0].imageGallery.length)
          || this.contactWeb.description[0].headline !== this.contactWebOrigin.description[0].headline
          || this.contactWeb.description[0].text1 !== this.contactWebOrigin.description[0].text1
          || this.contactWeb.description[0].text2 !== this.contactWebOrigin.description[0].text2) {
            hasChanges = true;
          }
          break;
        }
        case 'paymentMethods': {
          this.paymentMethods.forEach((payment) => {
            if (this.getPayment(this.contactWebOrigin, payment) && this.getPayment(this.contactWeb, payment)
            || !this.getPayment(this.contactWebOrigin, payment) && !this.getPayment(this.contactWeb, payment)) {
            } else { hasChanges = true; }
          });
          break;
        }
        case 'socialMedia': {
          this.socialMedias.forEach((social) => {
            if (this.getSocialMedia(this.contactWebOrigin, social.name).link !== this.getSocialMedia(this.contactWeb, social.name).link) {
              hasChanges = true;
            }
          });
          break;
        }
        case 'image': {
          if ((this.contactWeb.image ? this.contactWeb.image.url : '')
            !== (this.contactWebOrigin.image ? this.contactWebOrigin.image.url : '')) {
            hasChanges = true;
          }
          break;
        }
        case 'location': {
          break; // User cannot change this object, so we can ignore it
        }
        default: {
          if (this.contactWeb[key] !== this.contactWebOrigin[key]) {
            hasChanges = true;
          }
          break;
        }
      }
    }
    return hasChanges;
  }

  /**
   * Map result changes from user to this.contactWeb
   */
  applyDataChanges() {
    if (!this.contactWeb) { return; }
    for (const key of Object.keys(this.contactResult)) {
      switch (key) {
        case 'id': { break; }
        case 'updated': { break; }
        case 'updatedBy': { break; }
        default: {
          if (this.contactApp && key in this.contactApp) {
            this.contactApp[key] = this.contactResult[key];
          }
          if (this.contactWeb && key in this.contactWeb) {
            this.contactWeb[key] = this.contactResult[key];
          }
        }
      }
    }

    if (!this.includeHeaderImage) { this.contactWeb.image = null; }
    if (this.contactWeb.description && this.contactWeb.description.length > 0) {
      this.contactWeb.description[0].imageGallery = this.selectedImages;
    }

    this.applyMerchantChangeChanges();
  }

  /**
   * Map this.contactWeb keys to this.merchantChange
   */
  applyMerchantChangeChanges() {
    if (!this.merchantChange) { return; }
    for (const key of Object.keys(this.contactWeb)) {
      switch (key) {
        case 'id': { break; } // This is the wrong id. marketmanagerOriginalId is the correct contact id
        case 'marketmanagerOriginalId': {
          this.merchantChange.id = Number.parseInt(this.contactWeb[key]);
          break;
        }
        case 'description': {
          this.merchantChange.title = this.hasDescriptionAfter ? this.contactWeb.description[0].headline : '';
          break;
        }
        default: {
          if (key in this.merchantChange) {
            this.merchantChange[key] = this.contactWeb[key];
          }
          break;
        }
      }
    }
  }

  copyContactTemp() {
    const duplicateSame = this.selectedDuplicate === this.contactApp;
    if (this.contactTemp) {
      this.contactApp = classToClass(this.contactTemp);
      if (duplicateSame) { this.selectedDuplicate = this.contactApp; }
    }
  }

  /**
   * Compares contactResult[key] to contactApp[key] AND contactBefore[key]
   * @param key the key to use
   */
  compareResult(key: string): boolean {
    if (this.contactApp) {
      return this.contactResult[key] !== this.contactApp[key]
        && this.contactResult[key] !== (!this.contactBefore ? null : this.contactBefore[key]);
    }
    if (this.contactWeb) {
      if (key === 'radius') {
        return this.contactResult.radius !== this.merchantChange.radius;
      }
      return this.contactResult[key] !== this.contactWebOrigin[key];
    }
  }

  isFormValid(): boolean {
    if (this.contactResult.casIsCompany && !this.contactResult.country) {
      return false;
    }
    if (this.contactResult.casIsContact && this.countCompanyOwners() > 2 && this.selectedDuplicate === this.contactApp) {
      return false;
    }
    return true;
  }

  countCompanyOwners(): number {
    let count = 0;
    if (this.contactResult.casFunction === 'Inhaber/Geschäftsführer') { count ++; }
    if (this.possibleDuplicates && this.possibleDuplicates.length > 0) {
      count += this.possibleDuplicates.filter((item) => item.casFunction === 'Inhaber/Geschäftsführer').length;
    }
    return count;
  }

  enumKeys<O extends object, K extends keyof O>(obj: O): K[] {
    return Object.keys(obj).filter(k => Number.isNaN(+k)) as K[];
  }

  /**
   * Handles errors and displays an error modal to the user
   * @param error - The error object that was received
   * @param apiPath - The api path where the error occurred.
   */
  handleError(error: any, apiPath?: string) {
    if (error) {
      this.error = error;
      console.log(error.message, error);
    }
    this.error.apiPath = apiPath;
    this.modalService.open(this.errorModal, {size: 'sm'});
  }
}



// WEBPACK FOOTER //
// ./src/app/base-data/components/contact-detail/contact-detail.component.ts